// Existing eligibility policy and the postage requested by the unfreeze builder.
export const UNFREEZE_ELIGIBILITY_SATS = 546
export const UNFREEZE_POSTAGE_SATS = 330

type UnfreezeItem = { id?: string; outpoint?: string | { outpoint?: string; sats?: number }; utxoOutpoint?: string; sats?: number }

export function getUnfreezableSats(sats: unknown) {
	const amount = Number(sats)
	if (!Number.isSafeInteger(amount) || amount <= UNFREEZE_ELIGIBILITY_SATS) return 0
	return amount - UNFREEZE_POSTAGE_SATS
}

export function getUnfreezeSummary(items: UnfreezeItem[] = []) {
	const utxos = new Map<string, number>()
	for (const item of items) {
		const nested = typeof item.outpoint === 'object' ? item.outpoint : undefined
		const sats = Number(nested?.sats ?? item.sats)
		const key = nested?.outpoint || item.utxoOutpoint || item.id || (typeof item.outpoint === 'string' ? item.outpoint : undefined)
		if (key && getUnfreezableSats(sats) > 0) utxos.set(key, sats)
	}
	const totalSats = [...utxos.values()].reduce((sum, sats) => sum + sats, 0)
	const retainedSats = utxos.size * UNFREEZE_POSTAGE_SATS
	return { totalSats, retainedSats, excessSats: totalSats - retainedSats, utxoCount: utxos.size }
}

export function getUnfreezeNet(excessSats: number, networkFee: number, serviceFee: number) {
	if (![excessSats, networkFee, serviceFee].every(v => Number.isSafeInteger(v) && v >= 0)) return null
	return excessSats - networkFee - serviceFee
}
